import React from "react";
import "./Back_Btn.css";

const Back_Btn = (props) => {
  return (
    <button className="Back_Btn" onClick={props?.onClick}>
      <p className="btn_text">{props?.btn_name}</p>
    </button>
  );
};

export default Back_Btn;
